export const getWinnerOverviewPage = (company) => {
  return `/winner-ranking/winner-overview/${company ? `?find=${company}` : ''}`;
};
